/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetSingleAttachmentForSignature$Png$Params {

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;

/**
 * The attachment key
 */
  attachmentKey: KeyType;
  token: Token64LengthType;
}

export function externalGetSingleAttachmentForSignature$Png(http: HttpClient, rootUrl: string, params: ExternalGetSingleAttachmentForSignature$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, externalGetSingleAttachmentForSignature$Png.PATH, 'get');
  if (params) {
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('attachmentKey', params.attachmentKey, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/png', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

externalGetSingleAttachmentForSignature$Png.PATH = '/external/signature-pads/checkin/delivery-note/{deliveryNoteKey}/attachments/{attachmentKey}';
